import GetCategoriesRequestModelBase from '../_generated/modelBases/get-categories-request-model-base';

export default class GetCategoriesRequestModel extends GetCategoriesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
